// extracted by mini-css-extract-plugin
export default {"orderByHolder":"OrderByHolder_orderByHolder__839n7"};